// Application wide JS

document.addEventListener('turbolinks:load', function() {
  $('[data-toggle="tooltip"]').tooltip();
});
